import { render, staticRenderFns } from "./OdontogramsList.vue?vue&type=template&id=29cb129b"
import script from "./OdontogramsList.vue?vue&type=script&lang=js"
export * from "./OdontogramsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports